import { Skeleton } from '@nesso/ui/primitives/skeleton';

export function PlanBillingAlertSkeleton() {
    return (
        <div className="bg-card border-border relative rounded-md border p-6 mb-8 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
            <div className="flex flex-col gap-2">
                <Skeleton className="h-5 w-56" />
                <Skeleton className="h-4 w-72" />
            </div>
            <Skeleton className="h-7.5 w-28" />
        </div>
    );
}
